function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 14,
  fill: "#B6D7B4"
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_460_6361)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.6673 12H16.0007V8H12.0007V12H9.33398L14.0007 16.6667L18.6673 12ZM9.33398 18V19.3333H18.6673V18H9.33398Z",
  fill: "#0F570D"
}));
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_460_6361"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(6 6)"
})));
function SvgDownloadIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconTable);
export default __webpack_public_path__ + "static/media/download-icon-table.ddc94159.svg";
export { ForwardRef as ReactComponent };